import React, { useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip } from '@mui/material'
import { MdOutlineModeEdit } from 'react-icons/md'
import { Checkbox } from 'src/Common/ui/checkbox'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6'
import { cn } from 'src/lib/utils'
import { ROLENAME_CREATE_RISK, ROLENAME_UPDATE_RISK, ROLENAME_VIEW_COMPLIANCE, ROLENAME_VIEW_GOVERNANCE_SETUP, ROLENAME_VIEW_MANAGEMENT_TEAM, ROLENAME_VIEW_ORG_CHART, ROLENAME_VIEW_RISK, ROLENAME_VIEW_USER_MANAGEMENT } from 'src/Entities/RolePermissionEntities'

const RiskRolsAndPermissionsTable = ({ accordianOpen, features, riskRsData, setRiskRsData, riskRoles, setAccordianOpen, addState, setAddState, toggleDrawer }) => {
    // Handle checkbox toggle
    const handleCheckboxChange = (data, roleIndex, category) => {
        const finaldata = riskRsData.map((item, i) => {
            if (i === roleIndex) {
                item[data].status = !item[data]?.status
            }
            return item
        })
        setRiskRsData(finaldata)
    }
    useEffect(() => {
        if (riskRoles.length > 0) {
            const arr = []
            riskRoles.map(item => {
                const compRoleData = {
                    name: '',
                    id: item.id,
                    type: item.isPermanent,
                    expiryDate: item.expDate
                }
                compRoleData.name = item.role
                const temp = item.actionCombs
                temp.map(ele => {
                    compRoleData[`${ele.actionName}-${ele.subActionName}`] = {}
                    compRoleData[`${ele.actionName}-${ele.subActionName}`].status = ele.status
                    compRoleData[`${ele.actionName}-${ele.subActionName}`].roleId = item.roleId
                    compRoleData[`${ele.actionName}-${ele.subActionName}`].isDefault = ele.isDefault
                    compRoleData[`${ele.actionName}-${ele.subActionName}`].actionCombId = ele.combId
                    return ele
                })
                arr.push(compRoleData)
                return item
            })
            setRiskRsData(arr)
        } else {
            setRiskRsData([])
        }
    }, [riskRoles])

    return (
        <TableContainer component={Paper} className='global-table'>
            <Table aria-label="roles permissions table">
                <TableHead style={{ backgroundColor: 'hsl(var(--primary-table-head))' }}>
                    <TableRow>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 'bold', color: 'hsl(var(--primary))' }} align="center" rowSpan={2} ><span className='w-full h-full flex flex-row justify-center items-center'>{!accordianOpen?.risk ? <FaChevronDown style={{ cursor: 'pointer', marginRight: '20px' }} onClick={() => setAccordianOpen({ ...accordianOpen, risk: true })} /> : <FaChevronUp style={{ cursor: 'pointer', marginRight: '20px' }} onClick={() => setAccordianOpen({ ...accordianOpen, risk: false })} />} <span>Risk</span></span></TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 'bold', color: 'hsl(var(--primary))' }} align="center" colSpan={1} >Create</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 'bold', color: 'hsl(var(--primary))' }} align="center" colSpan={1} >Update</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 'bold', color: 'hsl(var(--primary))' }} align="center" colSpan={6} >View</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 500, color: 'hsl(var(--primary))' }} align="center">Risk</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 500, color: 'hsl(var(--primary))' }} align="center">Risk</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 500, color: 'hsl(var(--primary))' }} align="center">Organization Chart</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 500, color: 'hsl(var(--primary))' }} align="center">Management Structure</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 500, color: 'hsl(var(--primary))' }} align="center">Compliance Setup</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 500, color: 'hsl(var(--primary))' }} align="center">Risk</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 500, color: 'hsl(var(--primary))' }} align="center">Manage Compliance</TableCell>
                        <TableCell style={{ border: '1px solid hsl(var(--primary-thick-foreground))', fontWeight: 500, color: 'hsl(var(--primary))' }} align="center">User Management</TableCell>
                    </TableRow>
                </TableHead>
                {accordianOpen?.risk && <TableBody style={{ borderRadius: '20px' }}>
                    {riskRsData.map((role, roleIndex) => (
                        <TableRow key={role.role}>
                            <TableCell style={{
                                width: '330px',
                                borderLeft: '1px solid hsl(var(--primary-thick-foreground))',
                                borderBottom: '1px solid hsl(var(--primary-thick-foreground))',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexDirection: 'row'
                            }} component="th" scope="row" >
                                <span className='h-full flex flex-col'>
                                    <span className=''>{role.type ? 'Permanent Role' : 'Temporary Role'}</span>
                                    <span className='font-bold'>{role.name}</span>
                                </span>
                                <Tooltip title="Edit Role" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <div><MdOutlineModeEdit onClick={toggleDrawer('right', true, 'Edit Role', role.id)} color='hsl(var(--primary))' className='cursor-pointer h-[20px] w-[20px]' /></div>
                                </Tooltip>
                            </TableCell>
                            <TableCell className={cn(!role[ROLENAME_CREATE_RISK]?.isDefault ? '' : 'bg-popover pointer-events-none')} style={{ border: '1px solid hsl(var(--primary-thick-foreground))' }} align="center">
                                <Checkbox
                                    checked={role[ROLENAME_CREATE_RISK]?.status}
                                    onCheckedChange={() => handleCheckboxChange(ROLENAME_CREATE_RISK, roleIndex, 'risk')}
                                />
                            </TableCell>
                            <TableCell className={cn(!role[ROLENAME_UPDATE_RISK]?.isDefault ? '' : 'bg-popover pointer-events-none')} style={{ border: '1px solid hsl(var(--primary-thick-foreground))' }} align="center">
                                <Checkbox
                                    checked={role[ROLENAME_UPDATE_RISK]?.status}
                                    onCheckedChange={() => handleCheckboxChange(ROLENAME_UPDATE_RISK, roleIndex, 'update')}
                                />
                            </TableCell>
                            <TableCell className={cn(!role[ROLENAME_VIEW_ORG_CHART]?.isDefault ? '' : 'bg-popover pointer-events-none')} style={{ border: '1px solid hsl(var(--primary-thick-foreground))' }} align="center">
                                <Checkbox
                                    checked={role[ROLENAME_VIEW_ORG_CHART]?.status}
                                    onCheckedChange={() => handleCheckboxChange(ROLENAME_VIEW_ORG_CHART, roleIndex, 'organizationChart')}
                                />
                            </TableCell>
                            <TableCell className={cn(!role[ROLENAME_VIEW_MANAGEMENT_TEAM]?.isDefault ? '' : 'bg-popover pointer-events-none')} style={{ border: '1px solid hsl(var(--primary-thick-foreground))' }} align="center">
                                <Checkbox
                                    checked={role[ROLENAME_VIEW_MANAGEMENT_TEAM]?.status}
                                    onCheckedChange={() => handleCheckboxChange(ROLENAME_VIEW_MANAGEMENT_TEAM, roleIndex, 'update')}
                                />
                            </TableCell>
                            <TableCell className={cn(!role[ROLENAME_VIEW_GOVERNANCE_SETUP]?.isDefault ? '' : 'bg-popover pointer-events-none')} style={{ border: '1px solid hsl(var(--primary-thick-foreground))' }} align="center">
                                <Checkbox
                                    checked={role[ROLENAME_VIEW_GOVERNANCE_SETUP]?.status}
                                    onCheckedChange={() => handleCheckboxChange(ROLENAME_VIEW_GOVERNANCE_SETUP, roleIndex, 'view')}
                                />
                            </TableCell>
                            <TableCell className={cn(!role[ROLENAME_VIEW_RISK]?.isDefault ? '' : 'bg-popover pointer-events-none')} style={{ border: '1px solid hsl(var(--primary-thick-foreground))' }} align="center">
                                <Checkbox
                                    checked={role[ROLENAME_VIEW_RISK]?.status}
                                    onCheckedChange={() => handleCheckboxChange(ROLENAME_VIEW_RISK, roleIndex, 'view')}
                                />
                            </TableCell>
                            <TableCell className={cn(!role[ROLENAME_VIEW_COMPLIANCE]?.isDefault ? '' : 'bg-popover pointer-events-none')} style={{ border: '1px solid hsl(var(--primary-thick-foreground))' }} align="center">
                                <Checkbox
                                    checked={role[ROLENAME_VIEW_COMPLIANCE]?.status}
                                    onCheckedChange={() => handleCheckboxChange(ROLENAME_VIEW_COMPLIANCE, roleIndex, 'view')}
                                />
                            </TableCell>
                            <TableCell className={cn(!role[ROLENAME_VIEW_USER_MANAGEMENT]?.isDefault ? '' : 'bg-popover pointer-events-none')} style={{ border: '1px solid hsl(var(--primary-thick-foreground))' }} align="center">
                                <Checkbox
                                    checked={role[ROLENAME_VIEW_USER_MANAGEMENT]?.status}
                                    onCheckedChange={() => handleCheckboxChange(ROLENAME_VIEW_USER_MANAGEMENT, roleIndex, 'view')}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>}
            </Table>
        </TableContainer>
    )
}

export default RiskRolsAndPermissionsTable
